var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/codebuild/output/src2118274201/src/tv-monitor-ui/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/js/view/pages/DisplaysView.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"box\">\n    <div class=\"list-displays\">\n        <img class=\"xola-logo\" src=\"/img/xola-logo.png\" />\n\n        <div class=\"heading\">\n            <h3>Choose a display</h3>\n            <p>to continue to <b>xola.tv</b></p>\n        </div>\n\n        <div class=\"region-display-list\"></div>\n\n        <p>\n            <a href=\"#settings\" class=\"settings\">Configure your displays</a>\n        </p>\n\n        <div class=\"actions text-left\">\n            <button class=\"btn btn-default\" type=\"submit\">Back</button>\n        </div>\n    </div>\n\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/js/view/pages/DisplaysView.njk"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./src/js/view/pages/DisplaysView.njk
// module id = 262
// module chunks = 0